import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Esconder o conteúdo SEO estático após o React montar
// O Googlebot já leu o HTML inicial; agora o React assume a renderização
const seoPrerender = document.getElementById('seo-prerender');
if (seoPrerender) {
  seoPrerender.style.display = 'none';
}

createRoot(document.getElementById('root')!).render(
  <App />,
)
